<template>
  <select-dialog
    ref="selectDialog"
    :title="title"
    :row-data="rowData"
    :column-defs="columnDefs"
    :filter-keys="['templateName', 'pushLinkName']"
    :value="finalTemplateUuid"
    :event-name="eventName"
    :display-name-field="displayNameField"
    @change="changeTrigger"
  />
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
// import { queryAllPlatformInstructionByTenant } from '@/api/sysManage/baseConfig/instruction'
import SelectDialog from '@/components/SelectDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
export default {
  name: 'MailboxManagementDialog',
  components: { SelectDialog },
  props: {
    lob: {
      type: String,
      default: () => SE.code
    },
    pushLink: { // 选中的推送环节
      type: String,
      default: () => ''
    },
    mailTemplateUuid: { // 选中的模板
      type: String,
      default: () => ''
    },
    mailTemplates: { type: Array, default: () => [] }, //
    selectPushLink: { // true-选择推送环节 false-选择模板
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.PushingLink'),
          suppressMenu: true,
          width: 200,
          field: 'pushLinkName'
        }, {
          headerName: this.$t('Template.TemplateName'),
          suppressMenu: true,
          width: 200,
          field: 'templateName'
        }, {
          headerName: this.$t('SystemMaintenance.SubjectTemplate'),
          suppressMenu: true,
          width: 200,
          field: 'themeTemplate'
        }, {
          headerName: this.$t('SystemMaintenance.ContentTemplate'),
          suppressMenu: true,
          width: 200,
          field: 'contentTemplate'
        }, {
          headerName: this.$t('SystemMaintenance.Updater'),
          suppressMenu: true,
          field: 'modifiedByName',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.data.modifiedBy), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.opOffice'),
          suppressMenu: true,
          field: 'multipleOfficeIdName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          suppressMenu: true,
          field: 'lob',
          width: 200,
          cellRenderer: (params) => {
            if (params.value) {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SystemMaintenance.PushObject'),
          suppressMenu: true,
          field: 'multipleAccountIdName',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.LastUpdateTime'),
          suppressMenu: true,
          width: 200,
          field: 'dateModified'
        }
      ],
      eventName: '',
      displayNameField: '',
      pushLinkTemplate: {}
    }
  },
  computed: {
    finalTemplateUuid() {
      return this.selectPushLink ? this.pushLinkTemplate.uuid : this.mailTemplateUuid
    },
    title() {
      return this.selectPushLink ? this.$t('CargoMsg.Cargo_SelectThePushLink') : this.$t('CargoMsg.Cargo_SelectEmailTemplate')
    }
  },
  watch: {
    selectPushLink() {
      if (this.selectPushLink) {
        this.displayNameField = 'pushLinkName'
      } else {
        this.displayNameField = 'templateName'
      }
      this.eventName = ''
      this.pushLinkTemplate = {}
      if (this.$refs.selectDialog) {
        this.$refs.selectDialog.onReset()
      }
    },
    pushLink() {
      if (!this.pushLink) {
        this.eventName = ''
        this.pushLinkTemplate = {}
        if (this.$refs.selectDialog) {
          this.$refs.selectDialog.onReset()
        }
      }
    },
    mailTemplateUuid() {
      if (!this.mailTemplateUuid) {
        this.eventName = ''
        this.pushLinkTemplate = {}
        if (this.$refs.selectDialog) {
          this.$refs.selectDialog.onReset()
        }
      }
    }
  },
  created() {
    this.rowData = []
    this.eventName = ''
    if (this.selectPushLink) {
      this.displayNameField = 'pushLinkName'
    } else {
      this.displayNameField = 'templateName'
    }
    if (this.mailTemplates && this.mailTemplates.length > 0) {
      this.rowData = this.mailTemplates.filter(p => {
        return (!p.lob || p.lob === this.lob) &&
        (!p.multipleOfficeId || p.multipleOfficeId.split(',').includes(this.$store.getters.currentOfficeId + ''))
      })
      if (this.rowData && this.rowData.length > 0) {
        if (this.selectPushLink) {
          if (this.pushLink) {
            const emailTemplate = this.rowData.find(item => item.pushLink === this.pushLink)
            if (emailTemplate) {
              this.eventName = emailTemplate.pushLinkName
              this.pushLinkTemplate = emailTemplate
            }
          }
        } else {
          if (this.mailTemplateUuid) {
            const emailTemplate = this.rowData.find(item => item.uuid === this.mailTemplateUuid)
            if (emailTemplate) {
              this.eventName = emailTemplate.templateName
            }
          }
        }
      }
    }
  },
  methods: {
    changeTrigger(data) {
      this.$emit('change', data)
    }
  }
}
</script>
